import { ComponentProps, FC, ReactNode } from 'react';

import { formatNumber } from 'src/general/helpers/formatNumber';

import { BasicModal } from '../BasicModal/BasicModal';
import styles from './ModalGovernmentCharges.module.scss';

interface Props extends Omit<ComponentProps<typeof BasicModal>, 'id' | 'children' | 'title'> {
  carPrice: number;
  dutyPrice: number;
  transferFee: number;
  plateTransferFee: number;
  header?: ReactNode;
  excludingChargesText?: string;
  rmsHeader?: string;
  dutyText?: string;
  transferFeeText?: string;
  totalPriceText?: string;
  description?: ReactNode;
}

export const ModalGovernmentCharges: FC<Props> = ({
  carPrice,
  dutyPrice,
  transferFee,
  plateTransferFee,
  header = 'Price guide',
  excludingChargesText = 'Excluding Government charges',
  rmsHeader = 'Pay within 14 days after delivery to the RMS',
  dutyText = 'Motor Vehicle Duty',
  transferFeeText = 'Transfer Fee',
  totalPriceText = 'Estimated total price',
  description = '* Estimated total price is a guide only based on values provided by government authorities. These fees, duties and charges are subject to change and Carma does not provide any representation on their accuracy.',
  ...props
}) => (
  <BasicModal {...props} id="government-charges" title={header}>
    <dl className={styles.priceInitial}>
      <dt className={styles.priceInitialLabel}>{excludingChargesText}</dt>
      <dd className={styles.priceInitialValue}>
        {formatNumber(carPrice, { prepend: '$' })}
        <span className={styles.priceInitialValueNote}>(incl. GST)</span>
      </dd>
    </dl>
    <div className={styles.fees}>
      <h3 className={styles.feesTitle}>{rmsHeader}</h3>
      <dl className={styles.feesList}>
        <div className={styles.feeItem}>
          <dt className={styles.feeItemLabel}>{dutyText}</dt>
          <dd className={styles.feeItemValue}>{formatNumber(dutyPrice, { prepend: '$', append: '*' })}</dd>
        </div>
        <div className={styles.feeItem}>
          <dt className={styles.feeItemLabel}>{transferFeeText}</dt>
          <dd className={styles.feeItemValue}>{formatNumber(transferFee, { prepend: '$', append: '*' })}</dd>
        </div>
        <div className={styles.feeItem}>
          <dt className={styles.feeItemLabel}>Plate transfer fee</dt>
          <dd className={styles.feeItemValue}>{formatNumber(plateTransferFee, { prepend: '$', append: '*' })}</dd>
        </div>
      </dl>
    </div>
    <dl className={styles.priceTotal}>
      <dt className={styles.priceTotalLabel}>{totalPriceText}</dt>
      <dd className={styles.priceValue} data-testid="ModalGovernmentCharges-component-estimated-total">
        {formatNumber(carPrice + dutyPrice + transferFee + plateTransferFee, { prepend: '$', append: '*' })}
      </dd>
    </dl>
    <footer className={styles.footer}>{description}</footer>
  </BasicModal>
);
